var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex align-center justify-center bgError"},[_c('div',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('img',{attrs:{"src":require("@/assets/img/png/error404.png"),"alt":"value solutions"}})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }